import script from "./AdminProductEditorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductEditorPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductEditorPage.vue?vue&type=style&index=0&id=31013e3f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31013e3f"]])

export default __exports__